<template>
  <div>
    <v-select
      v-model="selectedCountry"
      :items="countriesSelect"
      :label="$t('country')"
      :menu-props="{ maxHeight: '400' }"
      outlined
      @input="changeCountry"
    >
    </v-select>
  </div>
</template>

<script>

import axios from 'axios';
import countries from '../countries.json';
import { DateTime } from 'luxon';
import { bus } from '../main';

export default {
  name: "country-changer",
  data: () => ({
    selectedCountry: null,
    currencies: null,
  }),
  mounted: function() {
    this.ensureCountrySet();
    this.getCurrenciesFromLocalStorage();
    this.ensureFreshCurrencies();
  },
  computed: {
    countriesSelect() {
      return Object.keys(countries);
    },
  },
  methods: {
    getCurrenciesFromLocalStorage() {
      if (localStorage.currencies) {
        this.currencies = JSON.parse(localStorage.currencies);
      }
    },
    async fetchCurrencies() {
      await axios.get('https://api.exchangeratesapi.io/latest')
      .then(response => {
        response.data.fetchTime = DateTime.local().toString();
        response.data.rates['EUR'] =  1;
        this.currencies = response.data;
        localStorage.currencies = JSON.stringify(response.data);
      });
    },
    ensureFreshCurrencies() {
      if(null === this.currencies) {
        this.fetchCurrencies();
        return;
      }

      let dateFromLocalstorage = DateTime.fromISO(this.currencies.fetchTime);
      let browserDate = DateTime.local();
      let diff = browserDate.diff(dateFromLocalstorage, 'hours');

      if(diff.toObject().hours >= 24) {
        this.fetchCurrencies();
      }
    },
    ensureCountrySet() {
      if(null === this.$cookies.get('country')){
        this.$cookies.set('country', 'DEU', '365d');
        this.$cookies.set('rate', 1, '365d');
      }

      this.selectedCountry = this.$cookies.get('country');
      bus.$emit('changeCountry', 
        this.$cookies.get('country'), 
        countries[this.$cookies.get('country')].currency, 
        countries[this.$cookies.get('country')].recommendedTip, 
        this.$cookies.get('rate')
      );
    },
    changeCountry(country) {
      this.selectedCountry = country;
      const currency = countries[country].currency;
      const recommendedTip = countries[country].recommendedTip;

      this.$cookies.set('country', country, '365d');
      this.$cookies.set('rate', this.currencies.rates[currency], '365d');

      bus.$emit('changeCountry', country, currency, recommendedTip, this.currencies.rates[currency]);
    }
  }
};
</script>
